export enum Geocoder {
    esriOnline = 'esriOnline',
    msiGeocoder = 'msiGeocoder',
    utahGeocoder = 'utahGeocoder',
    customEsriLocator = 'customEsriLocator',
    what3Words = 'what3Words',
    usng = 'usng',
    firstTwo = 'firstTwo',
}
